// extracted by mini-css-extract-plugin
module.exports = {"delete":"BankItemSection__delete--3JDGA","nodelete":"BankItemSection__nodelete--38-kQ","nodeleteText":"BankItemSection__nodeleteText--alFj7"};